import React, { useEffect, useState } from "react";
import { apiRequest } from "../../../hooks/apiRequest";
import { useParams, useLocation } from "react-router-dom";
import { useHistory } from "../../../utils/router";
import { getLink, objectToFormData, toast } from "../../../utils/helpers";
import Loader from "../../general/Loader";
import Form from "./Form";
import HistorialPaciente from "./Components/HistorialPaciente";
import { postRequest } from "../../../utils/request";
import { apiUrl } from "../../../utils/apiUrl";

const Edit = () => {
    const { id } = useParams();

    const history = useHistory();
    const location = useLocation();

    const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState({});
    const [saving, setSaving] = useState(false);
    const [visita, setVisita] = useState({});
    const [original, setOriginal] = useState({});
    const [esValido, setEsValido] = useState(false);

    const cancelar = () => {
        const from = location.state?.from || getLink("/salud/visitas");
        
        history.push(from);
    }

    const editarVisita = async () => {
        if (!esValido) return toast('Favor llenar todos los campos requeridos', 'error');

        setSaving(true);

        setErrors({});
        
        const data = objectToFormData({...visita, "_method": "put"});

        const response = await postRequest(apiUrl(`salud/visitas/${id}`), data);
                
        if (response.success) {
            history.push(getLink("/salud/visitas"));
        }

        if (response.code === 422) {
            setErrors(response.data.message);
        }

        setSaving(false);
    };

    const getVisita = async () => {
        const response = await apiRequest({}, `salud/visitas/${id}`, 'get');

        if (response.success) {
            setVisita(response.data);
            setOriginal(response.data);
        } else {
            toast('Error obteniendo la visita', 'error');
            cancelar();
        }

        setLoading(false);
    };

    useEffect(() => {
        getVisita();
    }, []);

    if (loading) return <Loader></Loader>;

    return <>
        <div className="row">
            <div className="col-md-6 order-2 order-md-1">
                <div className="card px-3 py-4" style={{borderRadius: '8px', minHeight: '100%'}}>
                    <h1>Editar Visita</h1>

                    <Form visita={visita} setVisita={setVisita} setEsValido={setEsValido} errors={errors} saving={saving} original={original} />
                </div>
            </div>

            <div className="col-md-6 order-1 order-md-2">
                {visita.paciente?.pacienteable_id 
                    ? <HistorialPaciente
                        saving={saving}
                        paciente={visita.paciente}
                        onChange={(paciente) => setVisita({
                            ...visita,
                            paciente,
                        })}
                    ></HistorialPaciente>
                    : <div className="card px-3 py-4" style={{borderRadius: '8px', minHeight: '100%'}}>
                        <div className="text-center"> Seleccione un paciente para ver el historial.</div>
                    </div>
                }
            </div>
        </div>

        <div className="row pt-4">
            <button
                type="button"
                className="btn btn-plain ml-auto mr-2"
                onClick={cancelar}
            >
                Descartar
            </button>

            <button
                type="button"
                className="btn btn-primary ml-2 mr-3"
                onClick={() => editarVisita()}
            >
                Guardar
            </button>
        </div>
    </>;
};

export default Edit;